// extracted by mini-css-extract-plugin
export default {"menu":"S1kNx2pOk9gjKWMqiVX_","manager":"B3oPtAMiw4fWw5ObYPjw"};